<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Patient Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Patient Details",
            items: [
               {
                  text: "Patients",
                  href: "/patients",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            patient: {},
            bookings_count : '',
            tokens_count: '',
            prescriptions: [],
            medical_reports: [],

            errors: {},
            token: '',

            password: '',
            password_confirmation: '',

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchPatient();
      },

      methods: {

         getToken() {
         if (localStorage.getItem('sigohealth_admin')) {
            var sigohealth_admin =  JSON.parse(localStorage.getItem('sigohealth_admin'));
            if(sigohealth_admin.token) {
               this.token = sigohealth_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      },

         fetchPatient() {
            let url = "api/admin/patient/profile?id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.patient = responseData.patient;  
               this.bookings_count = responseData.bookings;
               this.tokens_count = responseData.tokens;
               this.prescriptions = responseData.prescriptions;
               this.medical_reports = responseData.medical_reports;
                     
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },     

         updatePassword() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/patient/password";

            let formData = new FormData();
            formData.append("id", this.$route.params.id); 
            formData.append("password", this.password); 
            formData.append("password_confirmation", this.password_confirmation); 
            
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('password-modal');
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }, 

         clearForm()   {
            this.password = "";
            this.password_confirmation = "";
            this.errors = {};
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- Details starts -------->
                  <div class="row">
                     <div class=" col-lg-5 col-md-5">
                        <div class="card overflow-hidden">
                           <div class="bg-soft bg-primary">
                              <div class="row m-0">
                                 <div class="col-7">
                                 
                                 </div>
                                 <div class="col-5 align-self-end">
                                    <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                                 </div>
                              </div>
                           </div>
                           <div class="card-body pt-2">
                              <div class="row">
                                 <div class="col-sm-4">
                                    <div class="avatar-md profile-user-wid mb-1">
                                       <img src="@/assets/images/no-user.jpg"
                                       alt
                                       class="img-thumbnail rounded-circle"
                                       />
                                    </div>
                                    
                                 </div>
                                 <div class="col-sm-8 align-self-center">
                                    <h5 class="font-size-15">
                                       {{patient.name}}
                                    </h5>
                                    <p class="font-size-14 mt-3 mb-1">
                                       <i class="bx bx-phone me-1 text-primary"></i> 
                                       {{patient.mobile}}
                                    </p>
                                    <p class="font-size-14" v-if="patient.email">
                                       <i class="bx bx-envelope me-1 text-primary"></i>
                                       {{patient.email}}
                                    </p>

                                    <p class="font-size-14">
                                       <i class="bx bx-map me-1 text-primary"></i>
                                       {{patient.address}}
                                    </p>
                                 </div>
                              </div>                              

                           </div>
                        </div>
                        <!-- end card -->     
                        <div class="d-grid gap-2">
                           <b-button v-b-modal.password-modal block variant="primary">Change Password</b-button>
                           
                           <router-link :to="{ name: 'patients.edit', params: {id: $route.params.id} }" class="btn btn-primary">Edit Profile</router-link>  
                        </div>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                              <div class="avatar-sm align-self-center me-4 rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-stethoscope font-size-24"></i>
                                 </span>
                              </div>
                              <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Bookings</p>
                                 <h4 class="mb-0">{{bookings_count}}</h4>
                              </div>                              
                           </div>
                        </b-card>
                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                              <div class="avatar-sm align-self-center me-4 rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-certificate font-size-24"></i>
                                 </span>
                              </div>
                              <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Wallet Balance</p>
                                 <h4 class="mb-0" v-if="patient.coins">{{ patient.coins }} 
                                    <!-- <b-button v-b-modal.token-modal variant="outline-primary" class="btn-sm float-end">Wallet Logs</b-button> -->                               
                                 </h4>
                                 <h4 class="mb-0" v-else>0 
                                 </h4>
                                 <router-link :to="{ name: 'patients.wallet.logs', params: {id: $route.params.id} }" class="btn btn-outline-primary btn-sm float-end">Wallet Logs</router-link>

                                 
                              </div>                              
                           </div>
                        </b-card>

                        <!-- <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                              <div class="avatar-sm align-self-center me-4 rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-certificate font-size-24"></i>
                                 </span>
                              </div>
                              <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Tokens</p>
                                 <h4 class="mb-0">{{tokens_count}} <b-button v-b-modal.token-modal variant="outline-primary" class="btn-sm float-end">Add Token</b-button></h4>
                                 
                              </div>                              
                           </div>
                        </b-card> -->
                     </div>

                     <div class="col-lg-7 col-md-7">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 p-3 mb-3">Patient Details</h4>
                              

                              <div class="table-responsive ">
                                 <table class="table table-nowrap mb-0">
                                    <tbody>
                                       <tr width="50%">
                                          <th scope="row">Patient ID</th>
                                          <th>:</th>
                                          <td>{{patient.patient_id}}</td>
                                       </tr>
                                       <tr>
                                          <th scope="row">Gender</th>
                                          <th>:</th>
                                          <td>
                                             <span v-if="patient.gender==1">Male</span>
                                             <span v-if="patient.gender==2">Female</span>
                                             <span v-if="patient.gender==3">Others</span>
                                          </td>
                                       </tr> 

                                       <tr>
                                          <th scope="row">D.O.B</th>
                                          <th>:</th>
                                          <td>{{patient.dob | formatDate}}</td>
                                       </tr>  

                                       <tr>
                                          <th scope="row">Pincode</th>
                                          <th>:</th>
                                          <td>{{patient.pincode}}</td>
                                       </tr> 
                                       
                                       <tr>
                                          <th scope="row">Build version</th>
                                          <th>:</th>
                                          <td>{{patient.build_version}}</td>
                                       </tr> 

                                       <tr>
                                          <th scope="row">Created on</th>
                                          <th>:</th>
                                          <td>{{patient.converted_created_at}}</td>
                                       </tr>    
                                         
                                       <tr>
                                          <th scope="row">Created by</th>
                                          <th>:</th>
                                          <td>{{patient.added_user_name}}</td>
                                       </tr> 
                                    </tbody>
                                 </table>
                              </div>
                           
                        </b-card>
                        <!-- end card -->

                        <!-- <b-card header-class="bg-transparent border-light" class="border border-light mt-3">  
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Prescriptions</h4>
                           <ul class="list-inline p-0 m-0">                     
                              <li class="mb-3">                                 
                                 <a href="#"><p class="text-primary"><i class="fas fa-file-alt me-3"></i> Prescription 1</p></a>  
                              </li>

                              <li class="mb-3">                                 
                                 <a href="#"><p class="text-primary"><i class="fas fa-file-alt me-3"></i> Prescription 2</p></a>  
                              </li>
                              
                           </ul>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">  
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Medical Reports</h4>
                           <ul class="list-inline p-0 m-0">                     
                              <li class="mb-3">
                                 <a href="#"><p class="text-primary"><i class="fas fa-file-alt me-3"></i> Medical Report 1</p></a>  
                              </li>


                              <li class="mb-3">
                                 <a href="#"><p class="text-primary"><i class="fas fa-file-alt me-3"></i> Medical Report 2</p></a>  
                              </li>
                           </ul>
                        </b-card> -->

                     </div>
                     
                  </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
      <b-modal ref="password-modal" id="password-modal" title="Change Password" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="updatePassword()">
            <b-row>  
               <b-col lg="12" class="form-group">
                  <label class="control-label">New Password<span class="text-danger">*</span></label>
                  <b-form-input type="password" v-model="password"  v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>

                  <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>  

               <b-col lg="12" class="form-group">
                  <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                  <b-form-input type="password" v-model="password_confirmation"  v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>

                  <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>    
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                  <b-button class="" variant="light" @click="hideModal('password-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->

      <!---- modal starts ---->
      <b-modal ref="token-modal" id="token-modal" title="Add Token" hide-footer>
         <b-form>
            <b-row>                          

               <b-col md="12" class="form-group">
                  <label class="control-label">Count<span class="required">*</span></label>
                  <b-form-input></b-form-input>
                  
               </b-col>                           
                           
               <b-col md="12">
                  <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                  <b-button class="" variant="light" @click="hideModal('token-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
